import { cn } from "../../lib/utils"

/**
 * The GymBeam "G" mark, inlined so it paints in `currentColor` and follows the
 * light/dark ink of whatever it sits in — an `<img>` cannot inherit colour, and
 * this marker appears on both surfaces.
 *
 * The path is the visual-direction export verbatim; only the box is different. The
 * artboard file it comes from, and the derived favicons, live in
 * `public/brand/gymbeam-g-mark.svg` — change the path there and here together.
 * The mark is ~1.36:1, so size it by height and let the width follow.
 */
const MARK_PATH =
  "M97.95,480.64c0-14.3,2.2-29.15,5.5-42.9l-98.45-20.9,13.75-23.65h100.65c48.95-100.65,173.8-187.56,299.76-187.56,108.35,0,179.86,53.35,171.05,144.1h-123.2c13.2-47.3-4.95-80.85-46.75-80.85-86.35,0-209.01,118.8-209.01,228.26,0,33.55,15.95,75.35,62.15,75.35,34.65,0,85.8-25.3,117.7-73.15l-146.85-31.35c7.15-29.7,20.35-54.45,39.6-74.8h299.76c-3.3,13.2-8.25,28.05-15.95,46.75h-249.71l232.66,32.45c-67.1,111.65-178.2,163.35-276.66,163.35-109.45,0-176.01-59.95-176.01-155.1Z"

export function GymBeamMark({ className, title }: { className?: string; title?: string }) {
  return (
    <svg
      viewBox="5 205.63 585.94 430.11"
      fill="currentColor"
      className={cn("shrink-0", className)}
      role="img"
      aria-label={title ?? "GymBeam"}
    >
      <title>{title ?? "GymBeam"}</title>

      <path d={MARK_PATH} />
    </svg>
  )
}
